import 'react-app-polyfill/ie11';
import React from 'react';
import ReactDOM from 'react-dom';

import ConsumeConfig from './ConsumeConfig';

// rendering ConsumerConfig which contains the config api call
ReactDOM.render(
    <ConsumeConfig/>
  ,
  document.getElementById('app'),
);
